var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconIllustrationRegisters(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADB1",
    d: "M14 52.001h22.999V50H14zM14 22h22.999v-2H14z",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E97025",
    d: "M34.496 45.448L28 41.736 28.992 40 36 44zM15 44l6.504-4 .992 1.736L16 45.448z",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADB1",
    d: "M14 56.001h22.999V54H14zM43 22h23v-2H43zM43 26h23v-2H43zM43 30h23v-2H43zM43 38h23v-2H43zM43 34h23v-2H43z",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E97025",
    d: "M43 48h2v-2h-2zM51 48h2v-2h-2zM47 48h2v-2h-2zM43 44h2v-2h-2zM47 44h9v-2h-9zM19 34.86c0-4.964 1.685-6.86 6.208-6.86s6.209 1.896 6.209 6.86c0 4.392-2.443 8.16-6.209 8.16-3.765 0-6.208-3.769-6.208-8.16zm2 0c0 3.422 1.775 6.16 4.208 6.16 2.434 0 4.209-2.737 4.209-6.16 0-3.909-.846-4.86-4.209-4.86-3.362 0-4.208.951-4.208 4.86z",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39 62.252L35.168 60H12V16h22.624L39 18.572v43.68zM34.624 62l5.38 3.162.996-.586V17.428L35.168 14H10v48h24.624z",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41 62.252L44.832 60H68V16H45.376L41 18.572v43.68zm-2 2.31V17.427L44.832 14H70v48H45.376l-5.364 3.153L39 64.561z",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 26H18a4 4 0 00-4 4v12a4 4 0 004 4h15a4 4 0 004-4V30a4 4 0 00-4-4zm-15 2h15a2 2 0 012 2v12a2 2 0 01-2 2H18a2 2 0 01-2-2V30a2 2 0 012-2z",
    fill: "#E97025",
    className: "fi-icon-illustrative-highlight-fill"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h80v80H0z"
  }))));
}

export default SvgIconIllustrationRegisters;